import { render, staticRenderFns } from "./Cloudflare.vue?vue&type=template&id=4913bf54"
import script from "./Cloudflare.vue?vue&type=script&lang=js"
export * from "./Cloudflare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports